import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ModalIaResultsResumePage } from './modal-ia-results-resume.page';

const routes: Routes = [
  {
    path: '',
    component: ModalIaResultsResumePage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ModalIaResultsResumePageRoutingModule {}
